import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Renderer2
} from '@angular/core';

import { Model } from 'src/app/model/model';
import { WizEventManager, WizRoot } from '@wizeoo/akm-component-lib';
import { ALK_EVENT_TYPE, AlkEvent } from '@wizeoo/akm-common-lib';
import { APP_EVENT_TYPE } from 'src/app/model/enums';

@Component({
  selector: 'menu-panel',
  templateUrl: './menu.panel.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuPanel implements AfterViewInit  {

  // forçage de la taille par le menu
  @HostBinding('style.flex-basis') get width(): string {
    return this.currentSize + "px";
  }

  // écouteur de resize
  private _resizeObs: ResizeObserver;

  constructor(public elRef: ElementRef, private cdref: ChangeDetectorRef, private renderer: Renderer2) {
  }
  
  public baseSize: number = 50; // taille fermé
  public fullSize: number = 200; // taille full open
  public currentSize: number = this.baseSize;
  public maximize: boolean = false; // variable bascule

  public perfectWidth: string = '0px'; // la taille pour les libellés


  ngAfterViewInit(): void {
    WizEventManager.addListener(this, WizRoot.root(), APP_EVENT_TYPE.SWAP_PANEL, this.swapSize);
    this.listenToResize();
  }

  /**
   * ouverture / fermeture par le menu
   * @param e 
   */
  public swapSize(e: AlkEvent): void {

    this.maximize = !this.maximize;
    this.currentSize = this.maximize ? this.fullSize : this.baseSize;
    this.cdref.markForCheck();

    setTimeout(() => {
      this.cdref.markForCheck();
    }, 0);
  }

  /**
   * Ecoute de l'évènement resize
   */
  private listenToResize(): void {
    this._resizeObs = new ResizeObserver((entries: ResizeObserverEntry[], observer) => {
      this.onResize(entries[0].contentRect);
    })

    this._resizeObs.observe(this.elRef.nativeElement);
  }


  /**
   * Handler de resize
   */
  private onResize(contentRect: {width: number, height: number}) {
    
    let lblSize: number = Math.max(contentRect.width - 50, 0);
    this.perfectWidth = lblSize + 'px';
    // console.log('got resize', contentRect.width, this.perfectWidth);
    this.cdref.markForCheck(); // on demande un refresh pour afficher ou pas les labels
    
  }

  public showLabel(): boolean {
    // fetch styles for an element
    let style = window.getComputedStyle(this.elRef.nativeElement, null);
    let fb: string = style.getPropertyValue("flex-basis");
    let realSize: number = this.currentSize;
    if(fb) {
      realSize = Number(fb.slice(0, -2));
    }

    // fetch the property values for any style attribute
    // console.log('showLabel', realSize);

    if(realSize > 100) {
      return true;
    } 
    return false;
  }


   /** déclenche une action */
   public do(action: string): void {
     switch (action) {   
       case "add":  
         WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.ADD, null));
         break;      
       case "delete":
         WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.DELETE, null));
         break;
     }
   } 


  /** jump vers une vue */
  public go(view: string): void {
    Model.getInstance().navigationEngine.navigate(view);
  }
}
